// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3tPC3","inputWrap":"CustomTip_inputWrap__26nqE"};